module.exports = __webpack_public_path__ + "static/media/p5.195b9c95.png";